import { render } from "./UpgradeUsers.vue?vue&type=template&id=4bbf3699&scoped=true"
import script from "./UpgradeUsers.vue?vue&type=script&lang=js"
export * from "./UpgradeUsers.vue?vue&type=script&lang=js"

import "./UpgradeUsers.vue?vue&type=style&index=0&id=4bbf3699&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbf3699"]])

export default __exports__